import { parseShadowOrgSlug } from './tenantPath';

type TenantLike = {
  logoUrl?: string;
  name?: string;
  branding?: { logoUrl?: string; name?: string };
} | null | undefined;

/** Resolve logo URL from tenant API payload (top-level or nested branding). */
export function getTenantLogoUrl(tenant: TenantLike): string | null {
  if (!tenant) return null;
  const url = tenant.branding?.logoUrl || tenant.logoUrl;
  return url?.trim() || null;
}

/** Logo injected in HTML before React boots (custom-domain tenant sites). */
export function getEarlyTenantLogo(): string | null {
  if (typeof document === 'undefined') return null;
  const meta = document.querySelector('meta[name="tenant-logo"]');
  return meta?.getAttribute('content')?.trim() || null;
}

export function getEarlyTenantName(): string | null {
  if (typeof document === 'undefined') return null;
  const meta = document.querySelector('meta[name="tenant-name"]');
  return meta?.getAttribute('content')?.trim() || null;
}

export function isLikelyTenantSite(pathname: string): boolean {
  return !!parseShadowOrgSlug(pathname) || !!getEarlyTenantLogo();
}

export function resolveSplashLogo(tenant: TenantLike, pathname: string): {
  logoUrl: string | null;
  tenantName: string | null;
  isTenantContext: boolean;
} {
  const earlyLogo = getEarlyTenantLogo();
  const earlyName = getEarlyTenantName();
  const apiLogo = getTenantLogoUrl(tenant);
  const isTenantContext = !!tenant || !!earlyLogo || isLikelyTenantSite(pathname);

  return {
    logoUrl: apiLogo || earlyLogo,
    tenantName: tenant?.branding?.name || tenant?.name || earlyName,
    isTenantContext,
  };
}
